import axios from 'axios';
import endpoints from '../../endpoints';
import {handleError, handleResponse} from "./apiUtils";



// CSV Calls
export function uploadCsvFile(formData, callback) {
    const url = endpoints.uploadCsv;
    const config = {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    };

    return axios.post(url, formData, config)
        .then(handleResponse)
        .catch(handleError);
}

